import { DropDownMenuItem, MASSEGE_MENU_Type, MenuItem } from "../types";
import { ImgIcon } from "../utils/utils";

import deactivateIcon from "../assets/icons/Delete.svg";
import deleteIcon from "../assets/icons/DELETE __ DARK Red.svg";
import downSizeEvent from "../assets/icons/downSizeIcon.svg";
import { store } from "../lib/redux/store";

import AcademyIcon from "../assets/icons/AcademyIcon";
import CalendarIcon from "../assets/icons/CalendarIcon";
import HomeIcon from "../assets/icons/HomeIcon";
import AddForIcon from "../assets/icons/AddForIcon";
import AddPlayerIcon from "../assets/icons/AddPlayerIcon";
import AddServicesMenuIcon from "../assets/icons/AddServicesMenuIcon";
import BigCoach from "../assets/icons/BigCoachIcon";
import CardIcon from "../assets/icons/CardIcon";
import ClubIcon from "../assets/icons/ClubIcon";
import ClubCustomersIcon from "../assets/icons/ClubCustomersIcon";
import CopyIcon from "../assets/icons/CopyIcon";
import EditIcon from "../assets/icons/EditIcon";
import EyeClosedIcon from "../assets/icons/EyeClosedIcon";
import LeaguesIcon from "../assets/icons/LeaguesIcon";
import MatchCoachingIcon from "../assets/icons/MatchCoachingIcon";
import MessageIcon from "../assets/icons/MessageIcon";
import TournamentIcon from "../assets/icons/TournamentIcon";
import PaymentIcon from "../assets/icons/PaymentIcon";
import PosIcon from "../assets/icons/PosIcon";
import PricingIcon from "../assets/icons/PricingIcon";
import PublicEventsIcon from "../assets/icons/PublicEventsIcon";
import CourtsIcon from "../assets/icons/CourtsIcon";
import PaymentMethodIcon from "../assets/icons/PaymentMethodIcon";
import RepotIcon from "../assets/icons/RepotIcon";
import ShareIcon from "../assets/icons/ShareIcon";
import GameWithCoachIcon from "../assets/icons/GameWithCoachIcon";
import PublicCoachingIcon from "../assets/icons/PublicCoachingIcon";
import Clubsicon from "../assets/icons/Clubsicon";
import ClubAdminsIcon from "../assets/icons/ClubAdminsIcon";
import ImageIcon from "../components/global/ImageIcon";
import EyeOpenedIcon from "../assets/icons/EyeOpenedIcon";
import GenerateIcon from "../assets/icons/GenerateIcon";
import AddPlayerIconWithNumber from "../assets/icons/AddPlayerIconWithNumber";
import GenerateIconWithNumber from "../assets/icons/GenerateIconWithNumber";
import ScheduleCourtsIconwithNumber from "../assets/icons/ScheduleCourtsIconwithNumber";
import ScheduelIconWithNumber from "../assets/icons/ScheduelIconWithNumber";
import BlockCourtIcon from "../assets/icons/BlockCourtIcon";
import VouchersIcon from "../assets/icons/VouchersIcon";
import { Trash2Icon } from "lucide-react";

//@ts-ignore
const dictionary = store.getState().user.dictionary;
//------done-------//
export const MenuItems: MenuItem[] = [
  {
    title: "Home",
    href: "/home?viewType=court",
    tag: "Home",
    isGroupItem: false,
    Icon: HomeIcon,
  },
  {
    title: "Booking",
    href: "/booking?currentPage=1&currentSize=10",
    tag: "Booking",
    isGroupItem: false,
    Icon: CalendarIcon,
  },
  {
    title: "Coaching",
    href: "/coaching?currentPage=1&currentSize=10",
    tag: ["Academy", "Game With Coach", "Private Coaching", "Public Coaching"],
    isGroupItem: true,
    subMenu: [
      {
        title: "Academy",
        href: "/coaching/Academy?currentPage=1&currentSize=10",
        tag: "Academy",
        isGroupItem: false,
        //Icon: () => ImgIcon(AcademyIcon, 28, 28),
        Icon: AcademyIcon,
      },
      {
        title: "game with the coach",
        href: "/coaches/game?currentPage=1&currentSize=10",
        tag: "Game With Coach",
        isGroupItem: false,
        Icon: GameWithCoachIcon,
      },
      {
        title: "Private coaching",
        href: "/coaches/private/game?currentPage=1&currentSize=10",
        tag: "Private Coaching",
        isGroupItem: false,
        Icon: BigCoach,
      },
      {
        title: "Public coaching",
        href: "/coaches/public/game?currentPage=1&currentSize=10",
        tag: "Public Coaching",
        isGroupItem: false,
        Icon: PublicCoachingIcon,
      },
    ],
  },

  {
    title: "Events",
    href: "/events?currentPage=1&currentSize=10",
    tag: ["Leagues", "Tournaments", "Events"],
    isGroupItem: true,
    subMenu: [
      {
        title: "Leagues",
        tag: "Leagues",
        href: "/competitive/leagues?currentPage=1&currentSize=10",
        isGroupItem: false,
        Icon: LeaguesIcon,
      },
      {
        title: "Tournaments",
        href: "/competitive/tournaments?currentPage=1&currentSize=10",
        tag: "Tournaments",
        isGroupItem: false,
        Icon: TournamentIcon,
      },

      {
        title: "Public",
        href: "/friendly/public?currentPage=1&currentSize=10",
        tag: "Events",
        isGroupItem: false,
        Icon: PublicEventsIcon,
      },
      {
        title: "Private",
        href: "/friendly/private?currentPage=1&currentSize=10",
        tag: "Events",
        isGroupItem: false,
        Icon: EyeClosedIcon,
      },
    ],
  },
  // {
  //   title: "Competitive",
  //   href: "/competitive",
  //   isGroupItem: true,
  //   subMenu: [
  //     {
  //       title: "Leagues",
  //       href: "/competitive/leagues",
  //       isGroupItem: false,
  //       Icon: () => ImgIcon(leaguesIcon, 28, 28),
  //     },
  //     {
  //       title: "Tournaments",
  //       href: "/competitive/tournaments",
  //       isGroupItem: false,
  //       Icon: TournamentIcon,
  //     },
  //   ],
  // },
  // {
  //   title: "Friendly",
  //   href: "/friendly",
  //   isGroupItem: true,
  //   subMenu: [
  //     {
  //       title: "Public",
  //       href: "/friendly/public",
  //       isGroupItem: false,
  //       Icon: () => ImgIcon(publicEventsIcon, 28, 28),
  //     },
  //     {
  //       title: "Private",
  //       href: "/friendly/private",
  //       isGroupItem: false,
  //       Icon: () => ImgIcon(privateEventsIcon, 28, 28),
  //     },
  //   ],
  // },
  {
    title: "Organization Settings",
    href: "/club-settings",
    isGroupItem: true,
    tag: [
      "Organization",
      "Clubs",
      "Club Customers",
      "Club Admins",
      "Extras",
      "POS",
    ],
    subMenu: [
      {
        title: "Organization",
        href: "/club-settings/organization",
        tag: "Organization",
        isGroupItem: false,
        Icon: ClubIcon,
      },
      {
        title: "Clubs",
        href: "/club-settings/clubs?currentPage=1&currentSize=10",
        tag: "Clubs",
        isGroupItem: false,
        Icon: Clubsicon,
      },
      {
        title: "Coaches",
        href: "/club-settings/coaches?currentPage=1&currentSize=10",
        tag: "Coaches",
        isGroupItem: false,
        Icon: BigCoach,
      },
      {
        title: "Courts",
        href: "/club-settings/courts?currentPage=1&currentSize=10",
        tag: "Courts",
        isGroupItem: false,
        Icon: CourtsIcon,
      },
      {
        title: "Club Customers",
        href: "/club-settings/customer?currentPage=1&currentSize=10&sectionType=players",
        tag: "Club Customers",
        isGroupItem: false,
        Icon: ClubCustomersIcon,
      },
      {
        title: "club admins",
        href: "/club-settings/admin?currentPage=1&currentSize=10",
        tag: "Club Admins",
        isGroupItem: false,
        Icon: ClubAdminsIcon,
      },
      // {
      //   title: "Add-Ons and Services",
      //   href: "/club-settings/add-ons?currentPage=1&currentSize=10",
      //   tag: "Extras",
      //   isGroupItem: false,
      //   Icon: AddServicesMenuIcon,
      // },
      {
        title: "POS",
        href: "/club-settings/pos?currentPage=1&currentSize=10",
        tag: "POS",
        isGroupItem: false,
        Icon: PosIcon,
      },
    ],
  },
  {
    title: "General",
    href: "/general",
    isGroupItem: true,
    tag: ["Payments", "Pricing", "Payment Methods"],
    subMenu: [
      {
        title: "Payments",
        href: "/general/payments?currentPage=1&currentSize=10&viewType=transactions",
        tag: "Payments",
        isGroupItem: false,
        Icon: PaymentIcon,
      },

      {
        title: "Pricing",
        href: "/general/pricing?currentPage=1&currentSize=10",
        isGroupItem: false,
        tag: "Pricing",
        Icon: PricingIcon,
      },
      {
        title: "Payment methods",
        href: "/general/payment-methods?currentPage=1&currentSize=10",
        tag: "Payment Methods",
        isGroupItem: false,
        Icon: PaymentMethodIcon,
      },
       {
    title: "Report",
    href: "/dashboard",
    tag: "Report",
    isGroupItem: false,
    Icon: () => <RepotIcon  width={30} height={30} />,
  },
    ],
  },
 
];
//------done-------//
export const registration_menu: MenuItem[] = [
  {
    title: "Organization Settings",
    href: "/club-settings",
    isGroupItem: true,
    tag: [
      "Organization",
      "Clubs",
      "Club Customers",
      "Club Admins",
      "Extras",
      "POS",
    ],
    subMenu: [
      {
        title: "Organization",
        href: "/club-settings/organization",
        tag: "Organization",
        isGroupItem: false,
        Icon: ClubIcon,
      },
      {
        title: "Clubs",
        href: "/club-settings/clubs",
        tag: "Clubs",
        isGroupItem: false,
        Icon: Clubsicon,
      },
      {
        title: "Courts",
        href: "/club-settings/courts",
        tag: "Courts",
        isGroupItem: false,
        Icon: CourtsIcon,
      },
      {
        title: "Pricing",
        href: "/club-settings/pricing",
        tag: "Pricing",
        isGroupItem: false,
        Icon: PricingIcon,
      },
    ],
  },
];
export const getFilterBox = (navbar: any): MASSEGE_MENU_Type[] => [
  {
    name: navbar["Game with the coach"],
    tag: "gameWithCoach",
    icon: BigCoach,
    action: "gameWithCoach",
    eventType: "create",
    sections: ["Game With Coach"],
    color: "#1e1850",
  },
  {
    name: navbar.Academy,
    tag: "academy",
    icon: AcademyIcon,
    action: "academy",
    eventType: "create",
    sections: ["Academy"],
    color: "#1e1850",
  },
  {
    name: navbar["Private coaching"],
    tag: "privateCoaching",
    icon: BigCoach,
    action: "privateCoaching",
    eventType: "create",
    sections: ["Private Coaching"],
    color: "#1e1850",
  },
  {
    name: navbar["Public coaching"],
    tag: "Public coaching",
    icon: BigCoach,
    action: "PublicCoaching",
    eventType: "create",
    sections: ["Public Coaching"],
    color: "#1e1850",
  },
  {
    name: navbar.Leagues,
    tag: "Leagues",
    icon: LeaguesIcon,
    action: "Leagues",
    eventType: "create",
    sections: ["Leagues"],
    color: "#1e1850",
  },
  {
    name: navbar.Tournaments,
    tag: "Tournaments",

    icon: TournamentIcon,
    action: "Tournaments",
    eventType: "create",
    sections: ["Tournaments"],
    color: "#1e1850",
  },

  {
    name: navbar["Private match"],
    tag: "Private match",
    icon: MatchCoachingIcon,
    action: "private",
    eventType: "create",
    sections: ["Booking"],
    color: "#1e1850",
  },
  {
    name: navbar["Public match"],
    tag: "Public match",
    icon: MatchCoachingIcon,
    action: "public",
    eventType: "create",
    sections: ["Booking"],
    color: "#1e1850",
  },
  {
    name: "Block court",
    tag: "Private match",
    icon: BlockCourtIcon,
    action: "BlockCourt",
    eventType: "create",
    sections: ["Booking"],
    color: "#1e1850",
  },
];
//------done-------//
export const ClubBox: MASSEGE_MENU_Type[] = [
  {
    name: "Duplicate_Club",
    tag: "dublicateClub",
    translateSection: "organization",
    icon: CopyIcon,
    action: "dublicateClub",
    eventType: "create",
    sections: ["Organization", "Clubs"],
    color: "#1e1850",
  },
  {
    ///Renew package
    name: "Upgrade",
    translateSection: "organization",
    tag: "clubPlanEdit",
    icon: EditIcon,
    action: "clubPlanEdit",
    eventType: "write",
    sections: ["Organization", "Clubs"],
    color: "#1e1850",
  },
  {
    name: "edit",
    translateSection: "organization",
    tag: "edit",
    icon: EditIcon,
    action: "navigateToEditClub",
    eventType: "write",
    sections: ["Organization", "Clubs"],
    color: "#1e1850",
  },
  {
    name: "Deactivate_Club",
    translateSection: "organization",
    tag: "deactivateClub",
    icon: () => ImgIcon(deleteIcon, 28, 28),
    action: "deactivateClub",
    eventType: "delete",
    sections: ["Organization", "Clubs"],
    color: "#eb0707",
  },
];
//------done-------//
export const CoacheBox: MASSEGE_MENU_Type[] = [
  {
    name: "Edit",
    translateSection: "coaches",
    tag: "navigateToEditCoach",
    icon: EditIcon,
    action: "navigateToEditCoach",
    eventType: "write",
    sections: ["Coaches"],
    color: "#1e1850",
  },
  {
    name: "Deactivate_coach",
    tag: "deactivateCoach",
    icon: () => ImgIcon(deleteIcon, 28, 28),
    action: "deactivateCoach",
    eventType: "delete",
    sections: ["Coaches"],
    color: "#eb0707",
  },
];
//------done-------//
export const CourtBox: MASSEGE_MENU_Type[] = [
  {
    name: "Duplicate_court",
    translateSection: "courts",
    tag: "dublicateCourt",
    icon: CopyIcon,
    action: "dublicateCourt",
    color: "#1e1850",
    eventType: "create",
    sections: ["Courts"],
  },
  {
    name: "Edit_court",
    translateSection: "courts",
    tag: "navigateToEditCourt",
    icon: EditIcon,
    action: "navigateToEditCourt",
    eventType: "write",
    sections: ["Courts"],
    color: "#1e1850",
  },
  {
    name: "Deactivate_court",
    tag: "deactivateCourt",
    translateSection: "courts",
    icon: () => ImgIcon(deleteIcon, 28, 28),
    action: "deactivateCourt",
    eventType: "delete",
    sections: ["Courts"],
    color: "#eb0707",
  },
];
//------done-------//
export const CourtCoachesBox: MASSEGE_MENU_Type[] = [
  {
    name: "Profile_coach",
    translateSection: "coaches",
    tag: "navigateToEditCoach",
    icon: BigCoach,
    action: "navigateToEditCoach",
    eventType: "write",
    sections: ["Coaches"],
    color: "#1e1850",
  },
  {
    name: "Packages",
    translateSection: "coaches",
    tag: "navigateToCoachPackages",
    icon: CardIcon,
    action: "navigateToCoachPackages",
    color: "#1e1850",
    eventType: "write",
    sections: ["Coaches"],
  },
];

export const CarouselBox: MASSEGE_MENU_Type[] = [
  {
    name: "Add Image",
    tag: "AddImage",
    icon: AddForIcon,
    action: "uploadImage",
    eventType: "none",
    color: "#1e1850",
  },
  {
    name: "Delete Image",
    tag: "deleteImage",
    icon: () => ImgIcon(deleteIcon, 28, 28),
    action: "test",
    eventType: "none",
    color: "#eb0707",
  },
];
//-----done----//
export const PricingTableMenu: MASSEGE_MENU_Type[] = [
  {
    name: "Duplicate",
    translateSection: "pricing",
    color: "#1e1850",
    tag: "test14",
    action: "duplicate",
    eventType: "create",
    sections: ["Pricing"],
    icon: CopyIcon,
  },
  {
    name: "Configure",
    translateSection: "pricing",
    color: "#1e1850",
    tag: "edit",
    eventType: "write",
    sections: ["Pricing"],
    icon: EditIcon,
    action: "edit",
  },
  {
    name: "weekly_view",
    translateSection: "pricing",
    tag: "test194",
    icon: CalendarIcon,
    action: "weeklyView",
    eventType: "read",
    sections: ["Pricing"],
    color: "#1e1850",
  },
  {
    name: "",

    tag: "activatation",
    icon: () => ImgIcon(deactivateIcon, 28, 28),
    color: "#1e1850",
    action: "activatation",
    eventType: "delete",
    sections: ["Pricing"],
  },
  {
    name: "Delete",
    translateSection: "pricing",
    tag: "delete",
    icon: () => ImgIcon(deleteIcon, 28, 28),
    action: "delete",
    eventType: "delete",
    sections: ["Pricing"],
    color: "#EF4626",
  },
];
//-----done----//
export const usersClubMenu: MASSEGE_MENU_Type[] = [
  {
    name: "Edit user",
    translateSection: "clubs",
    color: "#1e1850",
    tag: "edit",
    icon: EditIcon,
    action: "edit",
    eventType: "write",
    sections: ["Club Admins"],
  },
  {
    name: "",
    tag: "activatation",
    icon: () => ImgIcon(deactivateIcon, 28, 28),
    color: "#1e1850",
    eventType: "delete",
    sections: ["Club Admins"],
    action: "activatation",
  },

  // {
  //   name: "Delete",
  //   tag: "test19",
  //   icon: () => ImgIcon(deleteIcon, 28, 28),
  //   action: "delete",
  //   color: "#EF4626",
  // },
];
//-----done----//
export const rolesClubMenu: MASSEGE_MENU_Type[] = [
  {
    name: "Edit role",
    translateSection: "clubs",
    color: "#1e1850",
    tag: "edit",
    eventType: "write",
    sections: ["Roles"],
    icon: EditIcon,
    action: "edit",
  },
  // {
  //   name: "Add account",
  //   tag: "test19",
  //   translateSection: "clubs",
  //   icon: ClubCustomersIcon,
  //   action: "addAccount",
  //   eventType: "create",
  //   sections: ["Clubs"],
  //   color: "#1e1850",
  // },
  {
    name: "",
    tag: "activatation",
    icon: () => ImgIcon(deactivateIcon, 28, 28),
    color: "#1e1850",
    action: "activatation",
    eventType: "delete",
    sections: ["Roles"],
  },
];
//-----done----//
export const customersMenu: MASSEGE_MENU_Type[] = [
  {
    name: "Edit",
    translateSection: "customers",
    color: "#1e1850",
    tag: "edit",
    icon: EditIcon,
    action: "edit_user",
    eventType: "write",
    sections: ["Club Customers"],
  },
  {
    name: "Membership Sale",
    color: "#1e1850",
    translateSection: "customers",
    tag: "membership_sale",
    icon: EditIcon,
    action: "buy_membership",
    eventType: "create",
    sections: ["Club Customers"],
  },
  {
    name: "player vouchers",
    color: "#1e1850",
    translateSection: "customers",
    tag: "player_vouchers",
    icon: VouchersIcon,
    action: "player_vouchers",
    eventType: "read",
    sections: ["Club Customers"],
  }
  // {
  //   name: "remove",
  //   tag: "delete",
  //   translateSection: "customers",
  //   icon: () => ImgIcon(deleteIcon, 28, 28),
  //   color: "#1e1850",
  //   action: "delete",
  //   eventType: "delete",
  //   sections: ["Club Customers"],
  // },

  // {
  //   name: "Delete",
  //   tag: "test19",
  //   icon: () => ImgIcon(deleteIcon, 28, 28),
  //   action: "delete",
  //   color: "#EF4626",
  // },
];
export const packagesMenu: MASSEGE_MENU_Type[] = [
  {
    name: "",
    tag: "activatationPackege",
    icon: () => ImgIcon(deactivateIcon, 28, 28),
    color: "#1e1850",
    action: "activatationPackege",
    eventType: "delete",
    sections: ["Club Customers"],
  },
  {
    name: "view",
    tag: "viewPackege",
    icon: EyeOpenedIcon,
    color: "#1e1850",
    action: "viewPackege",
    eventType: "read",
    sections: ["Club Customers"],
  },
];
export const walletMenu: MASSEGE_MENU_Type[] = [
  {
    name: "Duplicate voucher",
    translateSection: "wallet",
    color: "#1e1850",
    tag: "duplicate",
    icon: CopyIcon,
    action: "duplicate",
    eventType: "create",
    sections: ["Club Customers"],
  },
  //  {
  //   name:"Edit",
  //   translateSection:'wallet',
  //   color: "#1e1850",
  //   tag: "edit",
  //   icon: EditIcon,
  //   action: "edit",
  //   eventType: "write",
  //   sections: ["Club Customers"],
  // },
  {
    name: "Customers",
    translateSection: "wallet",
    color: "#1e1850",
    tag: "users",
    icon: ClubCustomersIcon,
    action: "show_users",
    eventType: "read",
    sections: ["Club Customers"],
  },
  {
    name: "Activation ",
    translateSection: "wallet",
    color: "#1e1850",
    tag: "activation",
    icon: EditIcon,
    action: "activation",
    eventType: "write",
    sections: ["Club Customers"],
  },
];
export const walletUserMenu: MASSEGE_MENU_Type[] = [
  {
    name: "Copy payment link ",
    translateSection: "wallet",
    color: "#1e1850",
    tag: "copyPaymentLink",
    icon: EditIcon,
    action: "copyPaymentLink",
    eventType: "read",
    sections: ["Club Customers"],
  },
  {
    name: "Activation ",
    translateSection: "wallet",
    color: "#1e1850",
    tag: "activation",
    icon: EditIcon,
    action: "activation",
    eventType: "write",
    sections: ["Club Customers"],
  },
];
//-----done----//
export const membershipsMenu: MASSEGE_MENU_Type[] = [
  {
    name: "Duplicate membership",
    translateSection: "customers",
    color: "#1e1850",
    tag: "edit",
    icon: EditIcon,
    action: "duplicate_membership",
    eventType: "create",
    sections: ["Club Customers"],
  },
  {
    name: "",
    tag: "activatation",
    icon: () => ImgIcon(deactivateIcon, 28, 28),
    color: "#1e1850",
    action: "activatation",
    eventType: "delete",
    sections: ["Club Customers"],
  },
  {
    name: "Customers",
    tag: "navigateToMembershipUsers",
    icon: ClubCustomersIcon,
    color: "#1e1850",
    action: "navigateToMembershipUsers",
    eventType: "none",
    sections: ["Club Customers"],
  },
  {
    name: "Edit membership",
    translateSection: "customers",
    color: "#1e1850",
    tag: "edit",
    icon: EditIcon,
    action: "edit_membership",
    eventType: "write",
    sections: ["Club Customers"],
  },
  // {
  //   name: "Delete",
  //   tag: "test19",
  //   icon: () => ImgIcon(deleteIcon, 28, 28),
  //   action: "delete",
  //   color: "#EF4626",
  // },
];
export const membershipSaleMenu = [
  {
    name: "Add Pause",
    translateSection: "customers",
    color: "#1e1850",
    tag: "add_pause",
    icon: EditIcon,
    action: "add_pause",
    eventType: "write",
    sections: ["Club Customers"],
  },
  {
    name: "Dectivatation",
    tag: "dectivatation",
    icon: () => ImgIcon(deactivateIcon, 28, 28),
    color: "#1e1850",
    action: "dectivatation",
    eventType: "delete",
    sections: ["Club Customers"],
  },
];
//-----done----//
export const bookingMenu: MASSEGE_MENU_Type[] = [
  {
    name: "Add Players",
    translateSection: "booking",
    action: "addPlayer",
    color: "#1e1850",
    icon: AddPlayerIcon,
    tag: "add",
    eventType: "write",
    sections: ["Booking"],
  },
  {
    name: "Edit Booking",
    translateSection: "booking",
    action: "edit",
    color: "#1e1850",
    icon: EditIcon,
    tag: "edit booking",
    eventType: "write",
    sections: ["Booking"],
  },
  {
    name: "Edit All Bookings",
    translateSection: "booking",
    action: "editAll",
    color: "#1e1850",
    icon: EditIcon,
    tag: "edit All booking",
    eventType: "write",
    sections: ["Booking"],
  },
  {
    name: "Duplicate",
    translateSection: "booking",
    action: "duplicate",
    color: "#1e1850",
    icon: CopyIcon,
    tag: "Duplicate booking",
    eventType: "create",
    sections: ["Booking"],
  },
  {
    name: "Share with players",
    translateSection: "booking",
    action: "share",
    color: "#1e1850",
    icon: ShareIcon,
    tag: "share",
    eventType: "none",
  },
  {
    name: "Chat with players",
    translateSection: "booking",
    action: "navigateToChat",
    color: "#1e1850",
    icon: MessageIcon,
    tag: "navigate",
    eventType: "read",
    sections: ["Chat"],
  },
  {
    name: "Cancel Booking",
    translateSection: "booking",
    action: "delete",
    color: "#EF4626",
    icon: () => ImgIcon(deleteIcon, 28, 28),
    tag: "deleteBooking",
    eventType: "delete",
    sections: ["Booking"],
  },
];
//-----done----//
export const playersMenu: MASSEGE_MENU_Type[] = [
  {
    name: "Chat",
    translateSection: "players",
    action: "chat",
    color: "#1e1850",
    icon: MessageIcon,
    tag: "chat",
    eventType: "read",
    sections: ["Chat"],
  },
  {
    name: "Remove player",
    translateSection: "players",
    action: "delete",
    color: "#EF4626",
    icon: () => ImgIcon(deleteIcon, 25, 25),
    tag: "delete",
    eventType: "delete",
    sections: ["Leagues"],
  },
  {
    name: "Player Details",
    translateSection: "players",
    action: "details",
    color: "#EF4626",
    icon: () => ImgIcon(deleteIcon, 28, 28),
    tag: "details",
    eventType: "read",
    sections: ["Leagues"],
  },
  // {
  //   name: "Copy Payment Link",
  //   translateSection: "players",
  //   action: "copyPaymentLink",
  //   color: "#1e1850",
  //   icon: MessageIcon,
  //   tag: "copyPaymentLink",
  //   eventType: "read",
  //   sections: ["Leagues"],
  // },
];
//-----done----//
export const waitingPlayersMenu: MASSEGE_MENU_Type[] = [
  {
    name: "Chat",
    translateSection: "players",
    action: "chat",
    color: "#1e1850",
    icon: MessageIcon,
    tag: "chat",
    eventType: "read",
    sections: ["Leagues"],
  },
  {
    name: "Add Player",
    translateSection: "players",
    action: "addPlayer",
    color: "#1e1850",
    icon: AddPlayerIcon,
    tag: "addPlayer",
    eventType: "write",
    sections: ["Leagues"],
  },
];
//-----done----//
export const leaguesMenu: MASSEGE_MENU_Type[] = [
  {
    name: "Add Players",
    translateSection: "leagues_tournaments",
    action: "addPlayer",
    color: "#1e1850",
    icon: AddPlayerIconWithNumber,
    tag: "addPlayer",
    eventType: "write",
    sections: ["Leagues", "Tournaments"],
  },
  {
    name: "Generate groups",
    translateSection: "leagues_tournaments",
    action: "generateGroups",
    color: "#1e1850",
    icon: GenerateIconWithNumber,
    tag: "generateGroups",
    eventType: "write",
    sections: ["Leagues"],
  },

  {
    name: "Schedule courts ",
    translateSection: "leagues_tournaments",
    action: "scheduleCourts",
    color: "#1e1850",
    icon: () => <ImageIcon width={38} Icon={ScheduleCourtsIconwithNumber} />,
    tag: "scheduleCourts",
    eventType: "write",
    sections: ["Leagues"],
  },
  {
    name: "Schedule",
    translateSection: "leagues_tournaments",
    action: "navigateToSchedule",
    color: "#1e1850",
    icon: ScheduelIconWithNumber,
    tag: "navigateToSchedule",
    eventType: "write",
    sections: ["Leagues"],
  },
  {
    name: "Down size",
    translateSection: "leagues_tournaments",
    action: "downSize",
    color: "#1e1850",
    icon: () => ImgIcon(downSizeEvent, 28, 28),
    tag: "downSize",
    eventType: "write",
    sections: ["Leagues"],
  },
  {
    name: "chat with players",
    translateSection: "leagues_tournaments",
    action: "chat",
    color: "1e1850",
    icon: MessageIcon,
    tag: "chat",
    eventType: "read",
    sections: ["Chat"],
  },

  {
    name: "Chart",
    translateSection: "leagues_tournaments",
    action: "navigateToChart",
    color: "#1e1850",
    icon: MatchCoachingIcon,
    tag: "navigateToChart",
    eventType: "none",
    sections: ["Leagues"],
  },
  {
    name: "Share with players",
    translateSection: "leagues_tournaments",
    action: "share",
    color: "#1e1850",
    icon: ShareIcon,
    tag: "share",
    eventType: "none",
  },
  {
    name: "Edit league",
    translateSection: "leagues_tournaments",
    action: "edit",
    color: "#1e1850",
    icon: EditIcon,
    tag: "edit",
    eventType: "write",
    sections: ["Leagues"],
  },
  {
    name: "Duplicate",
    translateSection: "leagues_tournaments",
    action: "duplicate",
    color: "#1e1850",
    icon: CopyIcon,
    tag: "Duplicate league",
    eventType: "create",
    sections: ["Leagues"],
  },
  {
    name: "Cancel League",
    translateSection: "leagues_tournaments",
    action: "delete",
    color: "#EF4626",
    icon: () => ImgIcon(deleteIcon, 28, 28),
    tag: "delete",
    eventType: "delete",
    sections: ["Leagues"],
  },
];
//-----done----//
export const eventsMenu: MASSEGE_MENU_Type[] = [
  {
    name: "Add Players",
    translateSection: "events",
    action: "addPlayer",
    color: "#1e1850",
    icon: AddPlayerIconWithNumber,
    tag: "addPlayer",
    eventType: "write",
    sections: ["Events"],
  },
  {
    name: "Schedule courts ",
    translateSection: "events",
    action: "scheduleCourts",
    color: "#1e1850",
    icon: () => (
      <div className="relative">
        <p className="font-bold absolute top-0 ">2</p>
        <ImageIcon className="ml-2" width={30} Icon={CourtsIcon} />
      </div>
    ),
    tag: "scheduleCourts",
    eventType: "write",
    sections: ["Events"],
  },
  // {
  //   name: "Generate matches",
  //   translateSection: "events",
  //   action: "generateMatches",
  //   color: "#1e1850",
  //   icon: () => (
  //     <div className="relative">
  //       <p className="font-bold absolute top-0 ">3</p>
  //       <ImageIcon className="ml-2" width={30} Icon={MatchCoachingIcon} />
  //     </div>
  //   ),
  //   tag: "generateMatches",
  //   eventType: "create",
  //   sections: ["Events"],
  // },
  {
    name: "Schedule",
    translateSection: "events",
    action: "navigateToSchedule",
    color: "#1e1850",
    icon: () => (
      <div className="relative">
        <p className="font-bold absolute top-0 ">3</p>
        <ImageIcon className="ml-2" width={30} Icon={CalendarIcon} />
      </div>
    ),
    tag: "navigateToSchedule",
    eventType: "write",
    sections: ["Events"],
  },
  {
    name: "Down size",
    translateSection: "events",
    action: "downSize",
    color: "#1e1850",
    icon: () => ImgIcon(downSizeEvent, 28, 28),
    tag: "downSize",
    eventType: "write",
    sections: ["Events"],
  },

  {
    name: "Share with players",
    translateSection: "events",
    action: "share",
    color: "#1e1850",
    icon: ShareIcon,
    tag: "share",
    eventType: "none",
    sections: ["Events"],
  },
  {
    name: "Edit event",
    translateSection: "events",
    action: "edit",
    color: "#1e1850",
    icon: EditIcon,
    tag: "edit",
    eventType: "write",
    sections: ["Events"],
  },
  {
     name: "Reset event",
    translateSection: "events",
    action: "reset",
    color: "#1e1850",
    icon: EditIcon,
    tag: "reset",
    eventType: "write",
    sections: ["Events"],
  },
  {
    name: "Duplicate",
    translateSection: "events",
    action: "duplicate",
    color: "#1e1850",
    icon: CopyIcon,
    tag: "Duplicate event",
    eventType: "create",
    sections: ["Events"],
  },
  {
    name: "Chat with players",
    translateSection: "events",
    action: "navigateToChat",
    color: "#1e1850",
    icon: MessageIcon,
    tag: "navigateToChat",
    eventType: "read",
    sections: ["Chat"],
  },
  {
    name: "Cancel League",
    translateSection: "events",
    action: "delete",
    color: "#EF4626",
    icon: () => ImgIcon(deleteIcon, 28, 28),
    tag: "delete",
    eventType: "delete",
    sections: ["Events"],
  },
];
//-----done----//
export const GameWithCoachBox: MASSEGE_MENU_Type[] = [
  {
    name: "Duplicate",
    translateSection: "coaches",
    action: "duplicate",
    color: "#1e1850",
    icon: CopyIcon,
    tag: "DuplicateGame",
    eventType: "create",
    sections: ["Game With Coach"],
  },
  {
    name: "Chat with players",
    translateSection: "coaches",
    action: "navigateToChat",
    color: "#1e1850",
    icon: MessageIcon,
    tag: "navigateToChat",
    eventType: "read",
    sections: ["Chat"],
  },
  {
    name: "Edit game",
    translateSection: "coaches",
    action: "edit",
    color: "#1e1850",
    icon: EditIcon,
    tag: "editGame",
    eventType: "write",
    sections: ["Game With Coach"],
  },
  {
    name: "Share with players",
    translateSection: "coaches",
    action: "share",
    color: "#1e1850",
    icon: ShareIcon,
    tag: "share",
    eventType: "none",
  },
  {
    name: "Cancel Booking",
    translateSection: "coaches",
    action: "delete",
    color: "#EF4626",
    icon: () => ImgIcon(deleteIcon, 28, 28),
    tag: "deleteBooking",
    eventType: "delete",
    sections: ["Game With Coach"],
  },
];
//-----done----//
export const PublicCoachingBox: MASSEGE_MENU_Type[] = [
  {
    name: "Add Players",
    translateSection: "coaches",
    action: "addPlayer",
    color: "#1e1850",
    icon: AddPlayerIcon,
    tag: "add",
    eventType: "write",
    sections: ["Public Coaching"],
  },
  {
    name: "Chat with players",
    translateSection: "coaches",
    action: "navigateToChat",
    color: "#1e1850",
    icon: MessageIcon,
    tag: "navigateToChat",
    eventType: "read",
    sections: ["Chat"],
  },
  {
    name: "Duplicate",
    translateSection: "coaches",
    action: "duplicate",
    color: "#1e1850",
    icon: CopyIcon,
    tag: "DuplicateGame",
    eventType: "create",
    sections: ["Public Coaching"],
  },
  {
    name: "Edit game",
    translateSection: "coaches",
    action: "edit",
    color: "#1e1850",
    icon: EditIcon,
    tag: "editGame",
    eventType: "write",
    sections: ["Public Coaching"],
  },
  {
    name: "Share with players",
    translateSection: "coaches",
    action: "share",
    color: "#1e1850",
    icon: ShareIcon,
    tag: "share",
    eventType: "none",
  },
  {
    name: "Cancel Booking",
    translateSection: "coaches",
    action: "delete",
    color: "#EF4626",
    icon: () => ImgIcon(deleteIcon, 28, 28),
    tag: "deleteBooking",
    eventType: "delete",
    sections: ["Public Coaching"],
  },
];
//-----done----//
export const AcademyBox: MASSEGE_MENU_Type[] = [
  {
    name: "Add Players",
    action: "addPlayer",
    translateSection: "Academy",
    color: "#1e1850",
    icon: AddPlayerIcon,
    tag: "add",
    eventType: "write",
    sections: ["Academy"],
  },
  {
    name: "Chat with players",
    translateSection: "Academy",
    action: "navigateToChat",
    color: "#1e1850",
    icon: MessageIcon,
    tag: "navigateToChat",
    eventType: "read",
    sections: ["Chat"],
  },
  {
    name: "Duplicate",
    translateSection: "Academy",
    action: "duplicate",
    color: "#1e1850",
    icon: CopyIcon,
    tag: "DuplicateGame",
    eventType: "create",
    sections: ["Academy"],
  },

  {
    name: "Share with players",
    translateSection: "Academy",
    action: "share",
    color: "#1e1850",
    icon: ShareIcon,
    tag: "share",
    eventType: "none",
  },
  {
    name: "Cancel Academy",
    translateSection: "Academy",
    action: "delete",
    color: "#EF4626",
    icon: () => ImgIcon(deleteIcon, 28, 28),
    tag: "deleteAcademy",
    eventType: "delete",
    sections: ["Academy"],
  },
];
//-----done----//
export const PrivateCoachingBox: MASSEGE_MENU_Type[] = [
  {
    name: "Duplicate",
    translateSection: "coaches",
    action: "duplicate",
    color: "#1e1850",
    icon: CopyIcon,
    tag: "DuplicateGame",
    eventType: "create",
    sections: ["Private Coaching"],
  },
  {
    name: "Chat with players",
    translateSection: "coaches",
    action: "navigateToChat",
    color: "#1e1850",
    icon: MessageIcon,
    tag: "navigateToChat",
    eventType: "read",
    sections: ["Chat"],
  },
  {
    name: "Edit game",
    translateSection: "coaches",
    action: "edit",
    color: "#1e1850",
    icon: EditIcon,
    tag: "editGame",
    eventType: "write",
    sections: ["Private Coaching"],
  },
  {
    name: "Share with players",
    translateSection: "coaches",
    action: "share",
    color: "#1e1850",
    icon: ShareIcon,
    tag: "share",
    eventType: "none",
  },
  {
    name: "Cancel Booking",
    translateSection: "coaches",
    action: "delete",
    color: "#EF4626",
    icon: () => ImgIcon(deleteIcon, 28, 28),
    tag: "deleteBooking",
    eventType: "delete",
    sections: ["Private Coaching"],
  },
];
export const chatMenu: MASSEGE_MENU_Type[] = [
  {
    name: "Delete",
    translateSection: "chat",
    action: "deleteMsg",
    color: "#1e1850",
    icon: Trash2Icon,
    tag: "deleteMsg",
    eventType: "delete",
    sections: ["Chat"],
  },
];
